import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_BASE_URL;

/* ---------------- FETCH BY TYPE ---------------- */
export const fetchCompanyByType = createAsyncThunk(
  'companyType/fetchByType',
  async (type, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_URL}/companies/descendant`);
      return response.data;
    } catch (err) {
      const msg = err.response?.data?.message || 'Failed to fetch companies by type';
      return rejectWithValue(Array.isArray(msg) ? msg.join(', ') : msg);
    }
  }
);

/* ---------------- FETCH BY HIERARCHY ---------------- */
export const fetchCompaniesByHierarchy = createAsyncThunk(
  'companyType/fetchByHierarchy',
  async ({ companyId }, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_URL}/companies/companyhierarchy/${companyId}`);
      console.log(response)
      return response.data;
    } catch (err) {
      const msg = err.response?.data?.message || 'Failed to fetch company hierarchy';
      return rejectWithValue(Array.isArray(msg) ? msg.join(', ') : msg);
    }
  }
);

const companyTypeSlice = createSlice({
  name: 'companyTypeList',
  initialState: {
    list: [],
    status: 'idle',
    error: null,
  },
  reducers: {
    clearCompanyType: (state) => {
      state.list = [];
      state.status = 'idle';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      /* Fetch By Type Lifecycle */
      .addCase(fetchCompanyByType.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchCompanyByType.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.list = action.payload;
      })
      .addCase(fetchCompanyByType.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })

      /* Fetch By Hierarchy Lifecycle */
      .addCase(fetchCompaniesByHierarchy.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchCompaniesByHierarchy.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.list = action.payload; // Flushes the array with the targeted hierarchy list
      })
      .addCase(fetchCompaniesByHierarchy.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export const { clearCompanyType } = companyTypeSlice.actions;
export default companyTypeSlice.reducer;